<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-dato-familiar />
    <h3 class="primary--text"><v-icon color="primary">people</v-icon> Datos familiares</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
              v-if="estado==1"
                color="primary"
                dark
                @click.native.stop="crearActualizarDatoFamiliar({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Dato familiar</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.nombre_completo }}</td>

            <td class="text-xs-center">
              {{
                items.item.parametro_parentesco == null
                  ? ""
                  : items.item.parametro_parentesco.valor
              }}
            </td>
            <td class="text-xs-center">{{ items.item.nacionalidad }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_nacimiento).format("DD/MM/YYYY") }}
            </td>

            <td class="text-xs-center">
              <v-tooltip bottom v-if="estado==1">
                <v-btn
                  icon
                  slot="activator"
                  color="primary"
                  @click.native="crearActualizarDatoFamiliar(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1">
                <v-btn
                  color="red"
                  dark
                  icon
                  slot="activator"
                  @click="deleteItem(items.item.id, 'datoFamiliar')"
                >
                  <v-icon color="dark">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarDatoFamiliar from "../dialogs/CrearActualizarDatoFamiliar"; // Componente de creación y actualización

export default {
  props: ['persona'],
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "datoFamiliars",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Nombre", value: "nombre_completo", align: "center" },

        {
          text: "Parentesco",
          value: "parametro_parentesco.valor",
          align: "center"
        },
        { text: "Nacionalidad", value: "nacionalidad", align: "center" },
        {
          text: "Fecha de Nacimiento",
          value: "fecha_nacimiento",
          align: "center"
        },

        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
       id
       nombre_completo
       nacionalidad
       fecha_nacimiento
       id_persona
       id_estado
       id_parametro_parentesco
       id_parametro_sexo
       
       parametro_parentesco{
         id
         valor
       }

       _user_created
       _user_updated
       _created_at
       _updated_at
      `,
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id,
        },
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    crearActualizarDatoFamiliar(item) {
      this.$bus.$emit("openDialogCrearActualizarDatoFamiliar", item);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $dato_familiar: EditDatoFamiliar!) {
              datoFamiliarEdit(id: $id, dato_familiar: $dato_familiar) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            dato_familiar: data
          }
        });
        if (value === 1) {
          this.$message.success("Dato Familiar habilitado");
        } else {
          this.$message.warning("Dato Familiar deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarDatoFamiliar
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/DatosFamiliares.vue